<div *ngIf="show" class="mb-4 blok">

  <div class="d-flex flex-row justify-content-between">

    <div>

  <div (click)="goToStudentPredmetyApp(zapisnyList)" [matTooltip]="('Moje predmety v' | translate) + ' ' + getZapisnyListTitle(zapisnyList)">
    <a>
      <b>
        <span i18n>Moje predmety v</span> {{getZapisnyListTitle(zapisnyList)}}
        <sup class="material-icons small">open_in_new</sup>
      </b>
    </a>
  </div>

  <div>
    <span class="fw-bold" i18n>Dátum zápisu</span>: {{zapisnyList.datumZapisu | date}}
  </div>

      <div *ngIf="zapisnyList.elektronickyZapis" class="d-inline-block">
        <div (click)="openElektronickyZapis()" [matTooltip]="('Môj zápis v' | translate) + ' ' + getZapisnyListTitle(zapisnyList)">
          <a>
            <span class="fw-bold" i18n>Môj zápis</span>:
            <div class="d-inline" *ngIf="zapisnyList.elektronickyZapis">
              <span i18n>vytvoreny</span>
              <div class="d-inline" *ngIf="zapisnyList.elektronickyZapisDate">,&nbsp;<span i18n>potvrdený dňa</span>: {{zapisnyList.elektronickyZapisDate|date}}</div>
              <div class="d-inline" *ngIf="!zapisnyList.elektronickyZapisDate">,&nbsp;<span i18n>neukončený</span></div>
            </div>
            <span *ngIf="!zapisnyList.elektronickyZapis" i18n>nevytvorený</span>
          </a>
        </div>
      </div>

      <div *ngIf="zapisnyList.poplatok">
        <span i18n>Zápis bol potvrdený študijným oddelením</span>
      </div>

      <div *ngIf="!zapisnyList.poplatok">
        <span i18n>Zápis ešte nebol potvrdený študijným oddelením</span>
      </div>


  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="harmonogramAkRoka()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Harmonogram akademického roka</span>
    </button>
    <button mat-menu-item (click)="odobratZapisnyList()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Odobrať zápisný list</span>
    </button>
    <button mat-menu-item (click)="tlacDokumentov()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Tlač dokumentov</span>
    </button>
  </mat-menu>

    </div>

    <div>
      <button mat-icon-button [matMenuTriggerFor]="menu" [matTooltip]="'Ďalšie možnosti' | translate">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>

  </div>

</div>
